import { escapeHTML } from './helpers';

export function plural (num: number | string, postfixes: [string, string, string] | string[]) {
  const asNumber = Number(num);
  if (isNaN(asNumber)) {
    return '';
  }

  const cases = [2, 0, 1, 1, 1, 2];
  return postfixes[asNumber % 100 > 4 && asNumber % 100 < 20 ? 2 : cases[Math.min(asNumber % 10, 5)]];
}

export function capitalizeFirstLetter (string: string) {
  if (!string?.length) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function initial (string: string) {
  if (!string?.length) {
    return '';
  }
  return string.charAt(0).toUpperCase();
}

export function replaceVariablesInTemplate (str: string, params: string[]) {
  return str.replace(/\{(\d+)\}/g, (match, index) => String(params[Number(index)]));
}

interface CustomInitialsArgs {
  name: boolean;
  surname: boolean;
  patronymic: boolean;
}
const defaultInitialArgs: CustomInitialsArgs = {
  name: true,
  surname: false,
  patronymic: true,
};

export function userNameWithInitialsFormatted (surname: string, name: string, patronymic: string, args: CustomInitialsArgs = defaultInitialArgs) {
  const rawParts = { surname, name, patronymic };
  let result = '';
  for (const key in rawParts) {
    const typedKey = key as keyof CustomInitialsArgs;
    let part = '';
    if (args[typedKey]) {
      part = initial(rawParts[typedKey]);
      if (part) {
        part += '.';
      }
    } else {
      part = capitalizeFirstLetter(rawParts[typedKey]);
    }
    if (part) {
      result += ` ${ part }`;
    }
  }
  return result;
}

export function getMaskedCharacters (text: string, searchString: string) {
  if (!searchString) {
    return { start: text, middle: '', end: '' };
  }
  const search = (searchString || '').toString().toLowerCase();

  const index = text.toLowerCase().indexOf(search);

  if (index < 0) {
    return { start: text, middle: '', end: '' };
  }

  const start = text.slice(0, index);
  const middle = text.slice(index, index + search.length);
  const end = text.slice(index + search.length);
  return { start, middle, end };
}
export function genFilteredText (text: string, searchString: string) {
  text = text || '';

  if (!searchString) {
    return escapeHTML(text);
  }

  const { start, middle, end } = getMaskedCharacters(text, searchString);

  return `${ escapeHTML(start) }${ genHighlight(middle) }${ escapeHTML(end) }`;
}
export function genHighlight (text: string) {
  return `<span class="vice--text">${ escapeHTML(text) }</span>`;
}
